import React from 'react';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

const Banner2 = () => {
  return (
    <div className={cx('commonBox')}>
      <span className={cx('desc')}>
        프로필 항목들을 빠짐없이 작성하려 노력했습니다.
        <br />
        매칭 제안도 많이 오고 합격률도 높아진 걸 느낄 수 있었어요.
      </span>
      <span className={cx('name')}>글로벌 IT기업 서비스기획 합격자 김상동님</span>
    </div>
  );
};

export default Banner2;
